import React from 'react';
import styles from './css/Input.module.css';

interface Props {
    value: string;
    onChange: (v: string) => void;
}

export const EmailInput: React.FC<Props> = ({ value, onChange }) => (
    <input
        className={styles.input}
        type="email"
        placeholder="Email Address"
        value={value}
        onChange={e => onChange(e.target.value)}
    />
);
